var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUsefulWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.90268 16.2928L9.51443 11.086C8.29374 8.85218 8.56854 5.92735 10.3534 3.9835C11.9294 2.19212 14.4315 1.56774 16.7202 2.30071C16.9908 2.34353 17.1428 2.55309 17.2046 2.74838C17.2521 3.03418 17.2094 3.3057 17.0006 3.45818L14.8716 5.76644C14.2877 6.39954 14.3354 7.38819 14.9775 7.96213C15.5935 8.51267 16.5339 8.48007 17.1103 7.88818L19.3465 5.59189C19.4652 5.42514 19.75 5.37745 19.9305 5.40599C20.2011 5.44881 20.3673 5.56786 20.5193 5.77742C21.4693 7.96843 20.9665 10.5791 19.4048 12.2798C17.6199 14.2236 14.8473 14.8055 12.4209 13.7722L8.04841 19.9171C7.36486 20.7366 6.28714 21.1226 5.29477 20.9656C4.84369 20.8943 4.49705 20.7467 4.07443 20.4943C3.40961 20.0181 3.07234 19.2226 3.00572 18.47C2.95332 17.6269 3.26181 16.8407 3.90268 16.2928Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsefulWhite);
export default __webpack_public_path__ + "static/media/useful-white.c6f85c5804fc2e81f929d71237cca26c.svg";
export { ForwardRef as ReactComponent };